/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios'
import {
  MAINHOST,
  TreeHOST,
  UPLOADHOST
} from "./config"
import {
  getDeviceType
} from '@/common/getDeviceType/getDeviceType'
import vue from '../main.js'
import {
  getURLParam
} from '@/utils/common'
// import Cookies from 'js-cookie'
// import {router} from '@/router/index'
// import {Message} from 'iview'

//axios配置
// ithCredentials = true; //让axios携带cookie
axios.defaults.timeout = 150000; //超时配置
// axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
// axios.defaults.baseURL = MAINHOST;
axios.defaults.retry = 3; //请求次数
axios.defaults.retryDelay = 1000;


/** 
 * 跳转安卓登录页
 *  
 */
const toLogin = () => {
  //这里需要调用安卓IOS
  var deviceType = getDeviceType();
  if (deviceType == "android") {
    window.android.getInfo(106, "3") //调用安卓
  } else {
    //调用IOS
    window.webkit.messageHandlers.closePage.postMessage("3");
  }
}
// 请求拦截器
axios.interceptors.request.use(
  config => {
    let  token = getURLParam("token");
    let phoneType = 'app';
    let treeToken = getURLParam("sysToken");
    let treeClient = getURLParam("sysClient");
    if (token) {
      config.headers = {
        token: token,
        client: phoneType,
        sysToken: treeToken,
        sysClient: treeClient,
      }
    } else {
      token = getURLParam("token");
      treeToken = getURLParam("sysToken");
      treeClient = getURLParam("sysClient");
      config.headers = {
        token: token,
        client: phoneType,
        sysToken: treeToken,
        sysClient: treeClient,
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
const errorHandle = (status, msg) => {

  // 状态码判断
  switch (status) {
    case "401":
      vue.$toast("登录失效！")
      setTimeout(() => {
        toLogin();
      },
        1000);
      break
    case "1107":
      vue.$toast("账号在其它地方登录，请重新登录！")
      setTimeout(() => {
        toLogin();
      },
        1000);
      break
    default:
      // vue.$Message.error(msg)
      console.log(msg);

  }
}
const handleReject = res => {
  // console.log(res,"res===")
  errorHandle(res.data.code, res.data.msg)
  return Promise.reject(res)
}


// 响应拦截器
axios.interceptors.response.use(
  // 请求成功
  res => {
    let state = res.data.code == '1' || res.data.code == undefined
    return res.status === 200 && state ?
      Promise.resolve(res) :
      handleReject(res)
  },
  error => {
    const {
      response
    } = error
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message)
      return Promise.reject(response)
    } else {
      if (error.code == "ECONNABORTED") {
        console.log(error.config, "error.config")
      } else {

        vue.$toast('服务器连接失败') // 处理断网的情况
      }

    }
  }
)

export const postRequest = (url, params, type) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      // url: `${MAINHOST}${url}`,
      url: type == 'oldTree' ? `${TreeHOST}${url}` : `${MAINHOST}${url}`,
      data: params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export const postRequestParams = (url, params, type) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      // url: `${MAINHOST}${url}`,
      url: type == 'oldTree' ? `${TreeHOST}${url}` : `${MAINHOST}${url}`,
      params: params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
export const postDataParams = (url, params, data) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'post',
      url: `${MAINHOST}${url}`,
      params: params,
      data: data
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const getRequest = (url, params, type) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      // url: `${MAINHOST}${url}`,
      url: type == 'oldTree' ? `${TreeHOST}${url}` : `${MAINHOST}${url}`,
      params: params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const deleteRequest = (url, params, type) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'delete',
      // url: `${MAINHOST}${url}`,
      url: type == 'oldTree' ? `${TreeHOST}${url}` : `${MAINHOST}${url}`,
      params: params
    })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const fileGet = (url, params) => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: `${UPLOADHOST}${url}`,
      params: params
    }).then(res => {
      resolve(res.data)
    })
      .catch(err => {
        reject(err)
      })
  })
}